import { RouterProvider } from 'react-router-dom';
import routes from './routing/Routes';
import './App.scss';

const App = () => {
  return <RouterProvider router={routes} />;
  // // const content = useRoutes(routes);
  // // return content;
};

export default App;
